import { createSelector } from 'reselect';

const userProfilePageSelector = state => state?.userProfilePageReducer ?? {};
const userTicketsSelector = state => userProfilePageSelector(state)?.tickets || [];
export const userSelectedTicketsIdsSelector = state => userProfilePageSelector(state)?.selectedTicketsIds || [];

// A single email can own several tickets in one event, each belonging to a
// different personId. Pairing every ticket with its own personId (rather than
// e.g. the first ticket's) ensures a ticket's registered sessions are never
// filtered out by another ticket's person.
export const personIdByTicketIdSelector = createSelector(
    userTicketsSelector,
    tickets => tickets.reduce((personIdByTicketId, { id, personId }) => {
        personIdByTicketId[id] = personId;
        return personIdByTicketId;
    }, {})
);

export const saveASeatErrorsSelector = state => userProfilePageSelector(state)?.saveASeatErrors || {};

// The person-scoped (ticket-less) registered-sessions endpoint takes a single
// person; unlike the per-ticket calls it has no ticket to resolve one from.
export const firstTicketPersonIdSelector = state => userTicketsSelector(state)[0]?.personId;
